export default __webpack_public_path__ + "static/media/757.fdc28aae.gif";